import React from 'react';
import PropTypes from 'prop-types';
import {Input} from 'antd';
const Search = ({onSearch, onChange}) => {
    return (
        <Input.Search
            onSearch={onSearch}
            onChange={onChange}
            size={'large'}
            style={{ width: '100%' }}
            placeholder='Փնտրել'
        />
    )
};

Search.propTypes = {
    onSearch: PropTypes.func.isRequired,
};

export default Search;